/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerAttributes } from '../models/CustomerAttributes';
import type { CustomerAttributesSelections } from '../models/CustomerAttributesSelections';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OpeningAttributesService {

    /**
     * Get Opening Attributes
     * @returns CustomerAttributes OK
     * @throws ApiError
     */
    public static getInternalApiFountainOpeningAttributes(): CancelablePromise<CustomerAttributes> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/fountain/opening_attributes',
        });
    }

    /**
     * Update Opening Attributes
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static patchInternalApiFountainOpeningAttributes(
        requestBody?: CustomerAttributesSelections,
    ): CancelablePromise<{
        success: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/internal_api/fountain/opening_attributes',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Unprocessable Entity`,
            },
        });
    }

}